<script>
import { authComputed, navComputed, optionsComputed } from '@/src/state/helpers'
import { constants } from '@src/constants/safehaven'
import AddHrDialog from '@/src/components/dialogs/add-hr-dialog.vue'
import CollapsibleList from '@/src/components/tables/safehaven-collapsible-list.vue'
import { healthRecordService } from '@/src/services/safehaven/HealthRecordService'
import moment from 'moment'
import store from '@/src/state/store'
export default {
  page: {
    title: 'Received Records',
    meta: [{ name: 'description', content: 'The Received Records page.' }],
  },
  components: { CollapsibleList, AddHrDialog },
  data() {
    return {
      addDialog: false,
      edit: false,
      loading: false,
      noDataFound: false,
      accessRevoked: false,
      hRecords: '',
      receivers: [],
      selectedReceipient: '',
      menuItems: constants.healthRecord,
      resourceItem: {},
      resourceMenuItem: {},
      group: null,
    }
  },
  computed: {
    ...authComputed,
    ...navComputed,
    ...optionsComputed,
    computedMenuItems() {
      return this.menuItems
    },
  },
  created() {
    this.getReciverList()
  },
  methods: {
    editItem({ item, resource, attachments }) {
      const menuItem = this.getMenuItemFromResource(resource)

      // Give as a prop to add-hr-dialog the menuItem
      this.resourceMenuItem = menuItem
      // Give as a prop item
      item.patient_id = ''
      this.resourceItem = item

      // Open dialog
      this.edit = true
      this.addDialog = true
      store.dispatch('calender/setAddNewRecords', 'false')

      if (attachments) {
        setTimeout(() => {
          store.dispatch('animations/setHighlightAttachments', true)
          const target = document.getElementById('#attachments')
          if (target) {
            this.$vuetify.goTo(target, {
              container: '#componentArea',
              duration: 800,
              easing: 'easeInOutCubic',
            })
          }
        }, 1000)
      }
    },
    getMenuItemFromResource(resource) {
      for (const key in this.menuItems) {
        if (this.menuItems[key].resource === resource) {
          return this.menuItems[key]
        }
      }
      return null
    },
    accessOk() {
      this.selectedReceipient = ''
      this.accessRevoked = false
      this.hRecords = null
      if (this.receivers.length === 2) this.noDataFound = true
    },
    async getReciverList() {
      try {
        this.loading = true
        const receiverList = (await healthRecordService.getReceiverRecords())
          .data

        if (receiverList) {
          this.loading = false
          this.receivers = receiverList.response
          if (this.receivers[0]) {
            this.noDataFound = false
            this.selectedReceipient = this.receivers[0].record_id
            this.receivers.unshift({
              sender_name: 'Select person',
              record_id: '',
            })
            this.getAllDataPatinet()
          } else {
            this.noDataFound = true
          }
        }
      } catch (error) {
        this.noDataFound = true
        this.loading = false
        console.warn(error)
      }
    },
    getFormatedDate(date) {
      const selected = this.receivers.find(
        (x) => x.record_id === this.selectedReceipient
      )
      return moment(selected.hr_expiration_date_time).format('MM/DD/YYYY')
    },

    async getAllDataPatinet() {
      try {
        const selected = this.receivers.find(
          (x) => x.record_id === this.selectedReceipient
        )
        this.receipentId = selected.record_id
        this.loading = true
        this.hRecords = null
        if (selected.is_access_revoked) {
          this.accessRevoked = selected.is_access_revoked
        } else {
          this.accessRevoked = selected.is_access_revoked
          const healthRecords = (
            await healthRecordService.getHealthRecordDataPatinet({
              patient_id: selected.sender_patient_id,
            })
          ).data
          if (healthRecords) {
            this.loading = false
            this.hRecords = null
            this.hRecords = healthRecords.results
            healthRecordService.setHealthRecordData(healthRecords)
            document.getElementById('fetchData').click()
          }
        }
      } catch (error) {
        this.loading = false
        healthRecordService.setHealthRecordData(null)
        document.getElementById('fetchData').click()

        console.warn(error)
      }
    },
  },
}
</script>

<template>
  <v-container fluid class="pa-0">
    <AddHrDialog
      :group="group"
      :dialog.sync="addDialog"
      :edit.sync="edit"
      :menu.sync="resourceMenuItem"
      :item.sync="resourceItem"
      :show="true"
    ></AddHrDialog>

    <v-row v-if="!noDataFound">
      <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="pb-0">
        <v-select
          v-model="selectedReceipient"
          :class="$style.selectUser"
          :items="receivers"
          item-text="sender_name"
          item-value="record_id"
          hide-details="true"
          outlined
          @change="getAllDataPatinet"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-else>
      <span :class="$style.noDataFoundCss">
        There are no records being shared with you.
      </span>
    </v-row>

    <v-card
      v-if="loading"
      width="100%"
      color="transparent"
      outlined
      rounded="lg"
      loading
      class="mt-4"
    >
      <template slot="progress">
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </template>
    </v-card>

    <div v-if="hRecords && !accessRevoked">
      <v-row class="mt-4">
        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
          <p :class="$style.topListNew">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :class="$style.btnClss"
                  v-bind="attrs"
                  @click="$store.dispatch('calender/setExpandAll', 'true')"
                  v-on="on"
                >
                  <img
                    :src="
                      require('@assets/images/Health-Record-Icons/icon-expand.svg')
                    "
                    class="imageproduit"
                  />
                </v-btn>
              </template>
              <span>Expand All</span>
            </v-tooltip>
            <!--Comma Added HERE-->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :class="$style.btnClss"
                  v-bind="attrs"
                  @click="$store.dispatch('calender/setExpandAll', 'false')"
                  v-on="on"
                >
                  <img
                    :src="
                      require('@assets/images/Health-Record-Icons/icon-collapse.svg')
                    "
                    class="imageproduit"
                  />
                </v-btn>
              </template>
              <span>Collapse All</span>
            </v-tooltip>
            <!--Comma Added END-->
          </p>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0"
          ><p :class="$style.expireClss" class="mb-0"
            ><v-icon>mdi-alert-outline</v-icon> Your access to these records
            will
            <span class="font-weight-bold"
              >expire on
              {{ getFormatedDate(selectedReceipient) }}
            </span></p
          ></v-col
        >
      </v-row>

      <v-row v-for="model in computedMenuItems" :key="model.plain_resource">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="pt-0 pb-0"
          fill-height
        >
          <v-fade-transition mode="out-in">
            <CollapsibleList
              v-if="!loading"
              :icon="model.icon"
              :color="model.color"
              :opaque="model.opaque"
              :headers="model.headers"
              :sortables="model.sortables"
              :title="$t(model.title)"
              :shared="true"
              :subtitle="
                model.list_title ? $t(model.list_title) : $t(model.title)
              "
              :image="model.imageURL"
              :resource="model.resource"
              :recipientid="receipentId"
              @show-item="editItem"
            ></CollapsibleList>
          </v-fade-transition>
        </v-col>
      </v-row>
    </div>
    <div v-if="accessRevoked">
      <div :class="$style.accessRevokedClass">
        <v-icon color="red">mdi-alert-outline</v-icon>&nbsp;Your access to these
        records has expired. Contact the owner to renew access.<a
          @click="accessOk"
          >OK</a
        >
      </div>
    </div>
    <v-row>
      <v-col> </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.accessRevokedClass {
  display: flex;
  flex: none;
  flex-grow: 0;
  align-items: center;
  order: 1;
  height: 24px;
  margin: 30px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #454648;
  letter-spacing: 0.1px;
}

.noDataFoundCss {
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  order: 0;
  width: 94%;
  height: 72px;
  padding: 24px 0;
  margin: 20px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}

.active {
  transform: rotate(-180deg);
}
.peerHeading {
  margin: 0 10px;
  font-size: 22px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}
.btnClss {
  padding: 0 !important;
  margin: 0 6px;
  font-size: 14px !important;
  color: #0476d9 !important;
  text-transform: capitalize;
  background: none !important;
  border: none;
  box-shadow: none !important;
}
.expireClss {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #454648;
  text-align: right;
  letter-spacing: 0.1px;
}
.btnClss:hover {
  background: none !important;
}

.btnClss:first-child {
  padding-right: 5px;
}
.listItem {
  border-radius: 8px !important;
}

.column {
  max-width: 150px;
  padding-right: 30px;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
}
.tabShareList {
  background: #f00;
}
.first {
  max-width: 100%;
}

.actionColumn {
  max-width: 40px;
}
.topListNew {
  padding: 0;
  margin: 0 !important;
  color: #c4c4c4;
  text-align: right;
  text-align: left;
}
.headerRow {
  width: 100% !important;
  min-height: 40px;
}

.listItemRow {
  width: 100% !important;
}

.title {
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.loaderPlaceholder {
  height: 4px;
}

.iconRow {
  height: 100%;
}

.iconContainer {
  border-radius: 3px;
}

.attachmentBtn {
  border: 1px solid $color-theme-light-placehold;
  border-radius: 24px !important;
}

.attachmentBtnText {
  max-width: 100px;
  font-size: 13px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.paddingclss {
  padding-left: 40px !important ;
}

@media screen and (max-width: 959px) {
  .expireClss {
    text-align: left;
  }
  .topListNew {
    display: none;
  }
}
</style>

<style scoped>
/deep/ .selectUser .v-text-field__details {
  display: none !important;
}
</style>
